import { render, staticRenderFns } from "./uploadFile.vue?vue&type=template&id=5870e840&scoped=true&"
import script from "./uploadFile.vue?vue&type=script&lang=js&"
export * from "./uploadFile.vue?vue&type=script&lang=js&"
import style0 from "./uploadFile.vue?vue&type=style&index=0&id=5870e840&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5870e840",
  null
  
)

export default component.exports